const tzOffsets = function () {
  return [
    {
      id: 'Europe/Kaliningrad',
      name: 'Калининградское время -1 MSK (+2 UTC)'
    },
    {
      id: 'Europe/Moscow',
      name: 'Московское время (+3 UTC)'
    },
    {
      id: 'Europe/Samara',
      name: 'Самарское время +1 MSK (+4 UTC)'
    },
    {
      id: 'Asia/Yekaterinburg',
      name: 'Екатерингбургское время +2 MSK (+5 UTC)'
    },
    {
      id: 'Asia/Omsk',
      name: 'Омское время +3 MSK (+6 UTC)'
    },
    {
      id: 'Asia/Krasnoyarsk',
      name: 'Красноярское время +4 MSK (+7 UTC)'
    },
    {
      id: 'Asia/Irkutsk',
      name: 'Иркутское время +5 MSK (+8 UTC)'
    },
    {
      id: 'Asia/Yakutsk',
      name: 'Якутское время +6 MSK (+9 UTC)'
    },
    {
      id: 'Asia/Vladivostok',
      name: 'Владивостокское время +7 MSK (+10 UTC)'
    },
    {
      id: 'Asia/Srednekolymsk',
      name: 'Среднеколымское время +8 MSK (+11 UTC)'
    },
    {
      id: 'Asia/Kamchatka',
      name: 'Камчатское время +9 MSK (+12 UTC)'
    }
  ]
}

export default tzOffsets



// WEBPACK FOOTER //
// ./src/helpers/tzOffsets.js